<label [ngClass]="disabled && 'disabled'">
  <input type="checkbox" [formControl]="control" class="check-custom" [attr.disabled]="disabled ? true : null" />
  <span class="check-toggle"></span>
  @if (text && text.length) {
    <span class="checkbox-text">{{ text }}</span>
  }
</label>
